import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
} from '@mui/material';

import './styles.css';
import { uploadImage } from '../../../services/firebaseStorage';
import { validateEmail } from '../../../utils';
import { useDispatch } from 'react-redux';
import { addCollege, updateCollege } from '../../../redux/actions/collegesActions';

function AddCollege({ isOpen, onClose, onSave, collegeToEdit }) {
  const dispatch = useDispatch();
  const [logoImage, setLogoImage] = useState(null);
  const [coverImage, setCoverImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newCollege, setNewCollege] = useState({
    name: '',
    path: '',
    coverImage: '',
    address: '',
    contactEmail: '',
    contactFullName: '',
    description: '',
    webSite: '',
    email: '',
    password: '',
  });

  const [formErrors, setFormErrors] = useState({
    name: '',
    address: '',
    contactEmail: '',
    contactFullName: '',
    description: '',
    webSite: '',
    email: '',
    password: '',
  });

  useEffect(() => {
    if (collegeToEdit) {
      setNewCollege(collegeToEdit);
      setLogoImage(collegeToEdit?.path);
      setCoverImage(collegeToEdit?.coverImage);
    } else {
      setNewCollege({
        name: '',
        path: '',
        coverImage: '',
        address: '',
        contactEmail: '',
        contactFullName: '',
        description: '',
        webSite: '',
        email: '',
        password: '',
      });
      setLogoImage(null); 
      setCoverImage(null); 
    }
  }, [collegeToEdit]);
  

  const validateForm = () => {
    const errors = {};
  
    for (const field of ['name', 'address', 'contactEmail', 'contactFullName', 'description', 'webSite', 'email']) {
      if (!newCollege[field]) {
        errors[field] = 'Ce champ est requis';
      }
    }
  
    if (!collegeToEdit && (!newCollege.password || newCollege.password.trim() === '')) {
      // Password is required for new colleges but not for editing
      errors.password = 'Mot de passe requis';
    }
  
    if (newCollege.email && !validateEmail(newCollege.email)) {
      errors.email = 'Format d\'email invalide';
    }
  
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCollege({
      ...newCollege,
      [name]: value,
    });
  };

  const handleFileChange = async (e, imageType) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const imageUrl = await uploadImage(file);
        if (imageType === 'path') {
          setLogoImage(imageUrl);
        } else if (imageType === 'coverImage') {
          setCoverImage(imageUrl);
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };
  

  const handleSaveCollege = async () => {
    if (!validateForm()) {
      return;
    }
    console.log("moussa");
    setIsLoading(true);
    try {
    
      var updatedCollege = {
        ...newCollege,
        path: logoImage,
        coverImage: coverImage,
      };
      
      if (collegeToEdit != null) {
        updatedCollege = {
          ...updatedCollege, 
          id: collegeToEdit?.id,
        };
      }
      setIsLoading(false);

      if (collegeToEdit!=null) {
        console.log("dispatch(updateCollege(updatedCollege));");
        dispatch(updateCollege(updatedCollege));
      } else {
        console.log("dispatch(addCollege(updatedCollege));");
        dispatch(addCollege(updatedCollege));
      }
      setLogoImage(null)
      setCoverImage(null)
      onSave(updatedCollege);
    } catch (error) {
      console.error('Error uploading images:', error);
      setIsLoading(false);
    }
  };

  const onCloseClick = () =>{
    setLogoImage(null)
    setCoverImage(null)
    onClose()
  }

  return (
    <Dialog open={isOpen} onClose={onCloseClick} maxWidth="md" fullWidth>
      <DialogTitle>{collegeToEdit ? 'Modifier' : 'Ajouter'} un collège</DialogTitle>
      <DialogContent className="add-college-dialog-content">
        <form>
          <TextField
            required
            label="Nom"
            name="name"
            fullWidth
            value={newCollege.name}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.name}
            helperText={formErrors.name}
          />
           <InputLabel htmlFor="logo-input">Logo</InputLabel>
          <FormControl fullWidth required error={!!formErrors.logo}>
            <Input
              id="logo-input"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'path')}
              disabled={isLoading}
              placeholder="Sélectionnez une image"
              aria-label="Aucun fichier sélectionné"
            />
           {logoImage && (
                      <img
                        src={logoImage}
                        alt="Logo sélectionné"
                        style={{ maxWidth: '100px', maxHeight: '100px' }}
                      />
          )}

            {formErrors.path && (
              <FormHelperText>{formErrors.path}</FormHelperText>
            )}
          </FormControl>
          <div>
          <InputLabel htmlFor="cover-input">Image de couverture</InputLabel>
          <FormControl fullWidth required error={!!formErrors.cover}>
            <Input
              id="cover-input"
              type="file"
              accept="image/*"
              placeholder="Sélectionnez une image"
              aria-label="Aucun fichier sélectionné"
              onChange={(e) => handleFileChange(e, 'coverImage')}
              disabled={isLoading}
            />
            {coverImage && (
              <img
                src={coverImage}
                alt="Image de couverture sélectionnée"
                style={{ maxWidth: '100px', maxHeight: '100px' }}
              />
            )}
            {formErrors.coverImage && (
              <FormHelperText>{formErrors.coverImage}</FormHelperText>
            )}
          </FormControl>
</div>

          <TextField
            required
            label="Adresse"
            name="address"
            fullWidth
            value={newCollege.address}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.address}
            helperText={formErrors.address}
          />
          <TextField
            required
            label="Email de contact"
            name="contactEmail"
            fullWidth
            value={newCollege.contactEmail}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.contactEmail}
            helperText={formErrors.contactEmail}
          />
          <TextField
            required
            label="Nom complet du contact"
            name="contactFullName"
            fullWidth
            value={newCollege.contactFullName}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.contactFullName}
            helperText={formErrors.contactFullName}
          />
          <TextField
            required
            label="Description"
            name="description"
            fullWidth
            value={newCollege.description}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.description}
            helperText={formErrors.description}
          />
          <TextField
            required
            label="Site web"
            name="webSite"
            fullWidth
            value={newCollege.webSite}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.webSite}
            helperText={formErrors.webSite}
          />
          <TextField
            required
            label="Email du collège"
            name="email"
            fullWidth
            value={newCollege.email}
            onChange={handleInputChange}
            margin="normal"
            error={!!formErrors.email}
            helperText={formErrors.email}
          />
          {!collegeToEdit && (
            <TextField
              required
              label="Mot de passe du collège"
              type="password"
              name="password"
              fullWidth
              value={newCollege.password}
              onChange={handleInputChange}
              margin="normal"
              error={!!formErrors.password}
              helperText={formErrors.password}
            />
          )}
        </form>
      </DialogContent>
      <DialogActions>
      <Button onClick={onClose} style={{ color: 'white', backgroundColor: '#FC6258' }}>
  Annuler
</Button>
<Button onClick={handleSaveCollege} style={{ color: 'white', backgroundColor: '#FC6258' }}>
  Enregistrer
</Button>

      </DialogActions>
    </Dialog>
  );
}

export default AddCollege;
